<template>
    <component
        :is="self ? 'MkA' : 'a'"
        ref="el"
        class="xlcxczvw _link"
        :[attr]="self ? url.substring(local.length) : url"
        :rel="rel"
        :target="target"
        :title="url"
        @click.stop
    >
        <slot></slot>
        <mg-icon
            v-if="target === '_blank'"
            icon="arrow-square-out"
            size="sm"
            class="icon"
        />
    </component>
</template>

<script lang="ts" setup>
import { defineAsyncComponent, ref } from "vue";
import { url as local } from "@/config";
import { useTooltip } from "@/composables/use-tooltip";

import { spawnPopover } from "@/components/layout/popover-layer";

const props = withDefaults(
    defineProps<{
        url: string;
        rel?: null | string;
    }>(),
    {},
);

const self = props.url.startsWith(local);
const attr = self ? "to" : "href";
const target = self ? null : "_blank";

const el = ref();

useTooltip(el, (showing) => {
    spawnPopover(
        defineAsyncComponent(
            () => import("@/components/MkUrlPreviewPopup.vue"),
        ),
        {
            url: props.url,
            source: el.value,
        },
        undefined,
        showing,
    );
});
</script>

<style lang="scss" scoped>
.xlcxczvw {
    word-break: break-all;

    > .icon {
        padding-left: 2px;
        font-size: 0.9em;
        vertical-align: super;
    }
}
</style>
